import EventReporter from 'appEvents';
import { AppEvents, EventProviders } from 'constants/events';
import {
  EVENT_TYPES,
  EVENT_CALENDAR_TRIGGERS,
} from './constants';
import { KEYS_LOCALSTORAGE } from 'constants/general';
import { RRuleSet, rrulestr } from 'rrule';

const {
  EVENT_CREATED,
  EVENT_DELETED,
  EVENT_MODIFIED,
  CALENDAR_EVENT_CLICKED,
  NEW_EVENT,
  CALENDAR_VIEW,
  SELECT_DATE,
} = EVENT_CALENDAR_TRIGGERS;

const DAILY_FREQUENCY = 3;
const WEEKLY_FREQUENCY = 2;

export const eventCalendarEventHandler = (event: any) => {
  switch (event.type) {
    case EVENT_CREATED:
      const {
        calendarEvent,
        user_role: userRole,
      } = event.data;

      let recurrencyType = 'doesNotRepeat';
      if (calendarEvent.rrule) {
        const rruleObject = rrulestr(calendarEvent.rrule, {
          forceset: true,
        }) as RRuleSet;
        const [rrule] = rruleObject.rrules();

        if (rrule.origOptions.interval) {
          recurrencyType = 'custom';
        } else {
          if (rrule.origOptions.freq) {
            const freq = rrule.origOptions.freq;

            if (freq === DAILY_FREQUENCY) {
              recurrencyType = 'daily';
            } else if (freq === WEEKLY_FREQUENCY) {
              const byWeekDay = rrule.origOptions.byweekday?.toString().split(',');

              if(byWeekDay?.length === 1) {
                recurrencyType = 'weekday';
              } else {
                recurrencyType = 'weekly';
              }
            }
          }
        }
      }

      let eventDuration = 'timeRange';

      if (calendarEvent.all_day) {
        eventDuration = 'allDay';
      } else if (calendarEvent.multiple_days) {
        eventDuration = 'acrossDays';
      }

      const types = {
        [EVENT_TYPES.CENTER]: 'forCenters',
        [EVENT_TYPES.CLASSROOM]: 'forClassrooms',
        [EVENT_TYPES.STUDENT]: 'forStudents',
      };

      const eventType = types[calendarEvent.type] || '';

      EventReporter.action(
        AppEvents.EVENT_CREATED({
          event_type: eventType,
          event_duration: eventDuration,
          notification: calendarEvent.notify_parents,
          user_role: userRole,
          recurrence: recurrencyType,
        }),
        [EventProviders.MIXPANEL],
      );
      break;
    case EVENT_MODIFIED:
      EventReporter.action(AppEvents.EVENT_MODIFIED({ sendEmail: event.data.sendEmail }), [
        EventProviders.MIXPANEL,
      ]);
      break;
    case EVENT_DELETED:
      EventReporter.action(AppEvents.EVENT_DELETED({ sendEmail: event.sendEmail ?? false }), [
        EventProviders.MIXPANEL,
      ]);
      break;
    case NEW_EVENT:
      EventReporter.view(AppEvents.S_CREATE_EVENT({
        user_role: event.data.user_role,
      }), [EventProviders.MIXPANEL]);
      break;
    case CALENDAR_VIEW:
      EventReporter.view(AppEvents.S_CALENDAR_HOME({
        center_name: localStorage.getItem(KEYS_LOCALSTORAGE.ACTIVE_CENTER_NAME),
      }), [
        EventProviders.MIXPANEL,
      ]);
      break;
    case SELECT_DATE:
      EventReporter.view(AppEvents.S_DAILY_PREVIEW(), [
        EventProviders.MIXPANEL,
      ]);
      break;
    case CALENDAR_EVENT_CLICKED:
      EventReporter.view(AppEvents.S_EVENT_DETAIL(), [EventProviders.MIXPANEL]);
      break;
    default:
  }
};
